module.exports = __webpack_public_path__ + "static/media/Waltherpartner.d0ebd6e4.svg";